module.exports = __webpack_public_path__ + "public/img/youhuishezhi@2x.8456ef68.png";